import React from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@chakra-ui/react';

import { ApplicationState } from '../../../store';
import { UserRole } from '../../../store/auth/types';
import { useTranslation } from "react-i18next";

const LockedSectionWarning: React.FC = () => {
    const { t } = useTranslation('common');
  const isAgent = useSelector(
    ({ auth }: ApplicationState) => auth.role === UserRole.Agent || auth.role === UserRole.AgencyAdmin,
  );

  return (
    <Alert status="info" colorScheme="cyan" mb={6} data-selector="locked-section-container">
      {isAgent ? (
        <>{t('common:noteTheUniversityIsProcessingThi')} </>
      ) : (
        <>
          {t('common:noteTheStudentCanNoLongerAccessO')}
                              </>
      )}
    </Alert>
  );
};

export default LockedSectionWarning;
